module.exports = __webpack_public_path__ + "static/media/bore1.69aad025.jpg";